import http, { API_CORE } from '../../http';

/**
 * Product Service for V2 API
 * All methods use /v2/products endpoints
 */
export default function ProductServiceV2() {
  const getProducts = async (params) => {
    const response = await http(API_CORE).get('/v2/products', { params });
    return response.data;
  };

  const getProductById = async (id) => {
    const response = await http(API_CORE).get(`/v2/products/${id}`);
    return response.data.product;
  };

  const createProduct = async (input) => {
    const response = await http(API_CORE).post('/v2/products', input);
    return response.data.product;
  };

  const updateProduct = async (productId, input) => {
    const response = await http(API_CORE).patch(`/v2/products/${productId}`, input);
    return response.data.product;
  };

  const deleteProduct = async (productId) => {
    const response = await http(API_CORE).delete(`/v2/products/${productId}`);
    return response.data;
  };

  const syncBillzProducts = async () => {
    const response = await http(API_CORE).post('/v2/products/sync/billz');
    return response.data;
  };

  const getBillzSyncStatus = async () => {
    const response = await http(API_CORE).get('/v2/products/sync/billz/status');
    return response.data;
  };

  const getProductAiSuggestion = async (input) => {
    const response = await http(API_CORE).post('/v2/products/ai-suggestion', input);
    return response.data;
  };

  return {
    getProducts,
    getProductById,
    createProduct,
    updateProduct,
    deleteProduct,
    syncBillzProducts,
    getBillzSyncStatus,
    getProductAiSuggestion,
  };
}
